const translations = {
  bulk_actions: 'Bulk Actions',
  new: 'New',
  sort: 'Sort',
  last_modified: 'Last modified',
  last_created: 'Last created',
  name_a_z: 'Name (A - Z)',
  name_z_a: 'Name (Z - A)',
  id: 'ID',
  newer_first: 'Newer first',
  older_first: 'Older first',
  higher_price: 'Higher price',
  lower_price: 'Lower price',
  year_newer: 'Year: newer',
  year_older: 'Year: older',
  more_impressions: 'More impressions',
  fewer_impressions: 'Fewer impressions',
  age_newer: 'Age: newer',
  age_older: 'Age: older',
  custom: 'Custom',
  asc: 'ASC',
  desc: 'DESC',
  showing_n: 'Showing {{n}} - {{z}}',
  n_selected: '{{n}} selected',

  export_current_page: 'Current page',
  export_all_contacts: 'All items',
  export_selected: 'Selected'
};

export default translations;
